import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'
import { DashboardCardItem } from 'shared/Dashboard'
import useStyle from 'shared/hooks/useStyle'

import styles from './DashboardCardCountedItem.style'

const propTypes = {
    count: PropTypes.number,
    titleKey: PropTypes.string.isRequired,
    infoKey: PropTypes.string,
    iconSrc: PropTypes.string.isRequired,
    linkTo: PropTypes.string.isRequired,
}

const DashboardCardCountedItem = ({
    titleKey,
    infoKey = 'OPEN_PROCESSES',
    linkTo,
    count = 0,
    iconSrc,
}) => {
    const classes = useStyle(styles)

    return (
        <DashboardCardItem
            titleKey={titleKey}
            infoKey={count > 0 ? infoKey : 'NO_OPEN_PROCESSES'}
            linkTo={count > 0 ? linkTo : undefined}
            iconSrc={iconSrc}
            customClasses={{ info: classes.countableInfo }}
        >
            { count > 0 ? (
                <Typography
                    variant="h3"
                    css={classes.countIndicator}
                >
                    {count}
                </Typography>
            ) : undefined}
        </DashboardCardItem>
    )
}

DashboardCardCountedItem.propTypes = propTypes

export default DashboardCardCountedItem
